module.exports = __webpack_public_path__ + "img/light.1e382f06.png";